import { useQuery } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { GetSavingGoalTransferDetailsParams } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

/**
 * Hook to fetch saving goal transfer details by ID
 */
export const useGetSavingGoalTransferDetails = (
  params: GetSavingGoalTransferDetailsParams,
) =>
  useQuery({
    queryKey: [
      QUERY_KEYS.SAVINGS_GOAL_TRANSFER_DETAILS,
      params.saving_goal_id,
      params.transfer_id,
    ],
    queryFn: () => transferServices.getSavingGoalTransferDetails(params),
    enabled: !!params?.saving_goal_id && !!params?.transfer_id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
